<template>
  <div class="artist-profile-slider artist-profile-slider-mobile slider-desktop">
    <div class="artist-profile-slider-container landing-slider-mobile" data-current="0">
      <Carousel
        class="artist-profile-carousel"
        @pageChange="setPage"
        :paginationPadding="5"
        :paginationSize="7"
        :per-page="1"
        :autoplay="true"
        :autoplayTimeout="5000"
        :loop="true"
      >
        <slide v-for="slider in artist.sliders" :key="slider.id" class="item">
          <div class="slider-item">
            <div v-if="slider.sold" class="ribbon-container large block">
              <a href="/artworks/just-sold">
                <div class="ribbon">
                  Sold
                  <div class="ribbon-top"></div>
                  <div class="ribbon-bottom"></div>
                </div>
              </a>
            </div>
            <a :href="slider.url">
              <img
                class="img-responsive img-max lazyload"
                :src="
                  $mq
                    | mq({
                      xs: slider.images.profile.slider_mobile,
                      sm: slider.images.profile.slider_desktop,
                      md: slider.images.profile.slider_desktop,
                      lg: slider.images.profile.slider_large,
                    })
                "
                :alt="slider.title"
              />
            </a>
          </div>
        </slide>
      </Carousel>
    </div>
    <div class="slider-controls">
      <div class="row">
        <div class="slider-controls-details col-xs-7">
          <div v-for="(slider, index) in artist.sliders" class="slider-artwork-details item-details item">
            <span class="slider-artwork" :class="{ active: sliderPage == index }" :data-index="index">
              <a class="text-uppercase" :href="slider.url">{{ slider.title }}</a
              >, {{ slider.dimensions }} - {{ slider.price.format }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel"

export default {
  name: "ArtistSliders",
  props: ["artist"],
  data() {
    return {
      sliderPage: 0,
    }
  },
  methods: {
    setPage(page) {
      this.sliderPage = page
    },
  },
  components: {
    Carousel,
    Slide,
  },
}
</script>

<style lang="scss" scoped>
::v-deep .VueCarousel-pagination {
  text-align: right !important;
  float: right;

  .VueCarousel-dot {
    button {
      background-color: #9b9b9b !important;
    }
    &.VueCarousel-dot--active {
      button {
        background-color: #4fa1c3 !important;
      }
    }
  }
}

.artist-profile-slider {
  margin-top: 0;

  @media screen and (max-width: theme("screens.md") - 1px) {
    margin-top: 30px;
  }

  .slider-item {
    @media (max-width: 1600px) and (min-width: theme("screens.md")) {
      img {
      }
    }
  }

  .slider-artwork {
    color: #222222;
    font-family: Lato;
    font-size: 16px;
    line-height: 19px;
    display: none;
    &.active {
      display: block;
    }
  }

  .slider-controls {
    margin-top: -20px;
  }

  .slider-controls-details {
    z-index: 3;
    width: 75%;
  }
}
</style>
